export default __webpack_public_path__ + "static/media/api.04aa7b5a.png";